import {ChangeEventHandler, KeyboardEvent, RefObject, useCallback} from 'react'
import {log} from 'common/log'
import {Key} from 'util/Key'

export function useSlctSharedCallbacks(
	setMenuOpen: (open: boolean) => void,
	setInputValue: (inputValue: string) => void,
	refInput: RefObject<HTMLInputElement | null>,
) {

	const onClickInput = useCallback(() => {
		setMenuOpen(true)
	}, [setMenuOpen])

	const onChangeInput = useCallback<ChangeEventHandler<HTMLInputElement>>((evt) => {
		log.trace('Slct onInputChange', evt)
		const val = evt.target.value || ''
		setInputValue(val)
	}, [])

	const onKeyUp = useCallback((evt: KeyboardEvent<HTMLInputElement>) => {
		log.trace('Slct onKeyUp', evt)
		if (evt.key !== Key.Tab && refInput.current === document.activeElement) setMenuOpen(true)
	}, [refInput.current, setMenuOpen])

	return {
		onClickInput,
		onChangeInput,
		onKeyUp,
	}
}